import { NotificationType } from "@/core/services/api/enums/NotificationType";
import { Notification } from "@/core/services/api/interfaces/manager/Notification";

const isFundsForAffiliateOwner = (n: Notification): boolean => {
  return NotificationType.TRANSACTION_FUNDS_FOR_AFFILIATE_OWNER === n.type;
};
const isSourceOfFundsWithAction = (n: Notification): boolean => {
  return (
    NotificationType.TRANSACTION_SOURCE_OF_FUNDS_MISSING === n.type &&
    n.notificationable &&
    "actions" in n.notificationable &&
    "is_legal_type_required" in n.notificationable.actions &&
    n.notificationable.actions.is_legal_type_required
  );
};

const isReportDownloadable = (n: Notification): boolean => {
  return (
    NotificationType.REPORT_GENERATED === n?.type &&
    n.notificationable &&
    "actions" in n.notificationable &&
    "is_downloadable" in n.notificationable.actions &&
    n.notificationable.actions.is_downloadable
  );
};

const isComplianceTrackingUploadable = (n: Notification): boolean => {
  return (
    !!~[
      NotificationType.COMPLIANCE_TRACKING_DOCUMENTS_MISSING,
      NotificationType.COMPLIANCE_TRACKING_DOCUMENTS_REJECTED,
    ].indexOf(n?.type) &&
    n.notificationable &&
    "compliable" in n.notificationable
  );
};

const isWithdrawable = (n: Notification): boolean => {
  return NotificationType.TRANSACTION_FLEXPSP_CREATE_WITHDRAW === n?.type;
};

const isNegativeBalance = (n: Notification): boolean => {
  return n.type === NotificationType.BANK_ACCOUNT_NEGATIVE_BALANCE;
};

export {
  isFundsForAffiliateOwner,
  isSourceOfFundsWithAction,
  isReportDownloadable,
  isComplianceTrackingUploadable,
  isNegativeBalance,
  isWithdrawable,
};
